<template>
  <div>
    <el-row>
      <EditViewForm 
        :handle_dynamic_form_update="handle_dynamic_form_update"
        :handle_file_upload="handle_file_upload"
        :page_structure="page_structure"
        :preloaded_data="context"
        :preloaded_rules="rules"
        :exported="exported"
        @update-valid="(valid)=>{form_valid = valid}"
        mode='edit'
        :preloaded_data_update_flag="preloaded_data_update_flag"
        />
    </el-row>    
    <el-row>
        <el-button type="primary" icon="el-icon-edit" @click="handle_save_button_click">儲存變更</el-button>
    </el-row>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/system_management_page/account_management_page/PasswordEditPageStructure'
import StructureUtils from '@/utils/StructureUtils'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'

  export default {
    components: {
      LoadingBlock,
      EditViewForm,
    },
    props: ['update_flag'],
    data() {
      return {
        loading: false,//TODO: change this to true
        page_structure: [],
        context: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/account',
        resource_identifier: 'id',
        options: {},
        file_lists: {},
        file: {},
        rules: {},
        exported: {},
        preloaded_data_update_flag: 0,
        form_valid: true
      }
    },
    watch : {
      update_flag () {
        this.init()
      }
    },
    check_given_password () {

    },
    created: async function () {
      this.init()
    },
    methods: {
      async init () {
        this.page_structure = PageStructure(this.$route.params.type)
        console.log('PasswordEditPage: page structure:', this.page_structure)
        
        this.rules = this.retrieve_validation_rule(this.page_structure)

        let temp = this.forge_context_container(this.page_structure)
        this.context = JSON.parse(JSON.stringify(temp))
        console.log('PasswordEditPage: context: ', this.context)

        await this.get_context()
        this.preloaded_data_update_flag += 1
      },
      handle_save_button_click () {
        console.log('save button clicked')

        if (!this.form_valid) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', '表格不符格式')
          return
        }

        if (typeof this.exported['form_ref'] !== 'undefined') {
          let self = this

          this.exported['form_ref'].validate((valid) => {
            if (!valid) {
              self.notify_message(self.ERROR.LEVEL.ERROR, '新增/編輯失敗', '表格不符格式')
              return 
            }

            if (self.context['new_password'] !== self.context['confirm_password']) {
              self.notify_message(self.ERROR.LEVEL.ERROR, '兩次輸入密碼必須一致', '')
              return
            }
            self.do_form_save()
          })
        }
        else {
          this.do_form_save()
        }
      },
      do_form_save() {
        let param = new FormData();
        
        // if (this.context['original_password'] !== this.context['password']) {
        //     //TODO: show warning
        //     this.notify_message(this.ERROR.LEVEL.ERROR, '原始密碼輸入錯誤', '')
        //     console.log('PasswordEditPage: original password is incorrect')
        //     console.log('oriPassword: ' + this.context['password'])
        //     return
        // }

        let config = { headers:{'Content-Type':'multipart/form-data'} }

        param.append('ori_password', this.context['original_password']);
        param.append('new_password', this.context['new_password']);
        param.append('confirm_password', this.context['confirm_password']);
        // param.append(this.resource_identifier, this.account_info['id']);

        this.loading = true
        axios.post(process.env.VUE_APP_API_BACKSTAGE_URL + '/user/reset-password', param, config)
          .then (response => { 
            this.loading = false
            if (!response.data.success) {
              console.log('save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '變更密碼失敗', response.data.message)
              return
            }
            this.notify_message(this.ERROR.LEVEL.SUCCESS, '變更密碼成功', '')
            console.log('save/edit succeed, response=', response)
            this.$emit('done')
          }) 
          .catch(({err}) => { 
            this.loading = false
            console.log('save/edit failed, err=', err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
          }) 
      },
      async get_context () {
        this.loading = true
  
        await this.action_get_personal_info()

        let res = this.translate_to_display_data(this.account_info)
        for (let key in res) {
            this.context[key] = res[key]
        }
        this.context['password'] = res['password']

        this.loading = false
      },
      handle_file_upload (file_list_name, file) {
        console.log('handle file upload: file=',file_list_name, file)
      },
      translate_to_display_data(data) {
        let types = StructureUtils.structure_to_edit_type_map(this.page_structure)

        let translated_data = data
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            if (data[key]) {
              translated_data[key] = data[key].date.slice(0,-7)
            }
          }
        }
        
        return translated_data
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('PasswordEditPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.context, key, form_value)
      }
    }
  };
</script>

<style>
</style>
